// extracted by mini-css-extract-plugin
module.exports = {"value":"style_value__fWmGF","multiValue":"style_multiValue__Y9ss5","highlight":"style_highlight__1MHae","field":"style_field__366TV","search-icon":"style_search-icon__3cWzl"};